import { render, staticRenderFns } from "./BuyRecordDetail.vue?vue&type=template&id=37baec3a&scoped=true&"
import script from "./BuyRecordDetail.vue?vue&type=script&lang=js&"
export * from "./BuyRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./BuyRecordDetail.vue?vue&type=style&index=0&id=37baec3a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37baec3a",
  null
  
)

export default component.exports